export default __webpack_public_path__ + "static/media/inspectoere-confirm-disable.d1b150ea.svg";